<script setup lang="ts">
import { RouterView } from 'vue-router'
import AppContext from '@/components/AppContext.vue'

import { dynamicRenderElementId } from '@/constant/app'
import versionCheckService from '@/utils/versionCheckService'

versionCheckService()
</script>

<template>
  <AppContext>
    <main class="h-full overflow-hidden">
      <RouterView v-slot="{ Component }">
        <component :is="Component" />
      </RouterView>

      <Teleport to="body">
        <div :id="dynamicRenderElementId" />
      </Teleport>
    </main>
  </AppContext>
</template>
